export default __webpack_public_path__ + "static/twitterpreview-f1bba4f8acdebc5a9e2e055105fb9c25.png";